import React, { useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { parseClasses } from '../../lib/ep.js';

import { SquaredButton } from './ActionButton';
import ButtonCollection from './ButtonCollection';
import FieldErrorMessage from './FieldErrorMessage';
import FieldLabel from './FieldLabel';
import FileUploader from './FileUploader';
import ProgressBar from './ProgressBar';
import UrlField from './UrlField';

const VideoPicker = (props)=> {
	const [state,setState] = useState({
		origin:'upload',
		progress:0,
		progress_status:null,
		progress_status_text:"",
		value:(props.value != undefined) ? props.value : ((props.model != undefined && props.model[props.name] != null) ? props.model[props.name] : '')
	})

	const initial_percent_loaded = 15;

	const file_uploader = useRef();
	
	const progress_upload = (video) => {
		setState(state=>({
			...state,
			progress:initial_percent_loaded,
			progress_status:null,
			progress_status_text:"",
		}));

		$.ajax({
			url:props.upload_url,
			type:'post',
			data:{
				video:video,
			},
			dataType:'json',
			xhr:() => {
				var xhr = $.ajaxSettings.xhr();
				xhr.upload.onprogress = (e) => {
					if(e.lengthComputable) {
						setState(state=>({...state, progress:initial_percent_loaded + Math.ceil(100 * (1 - initial_percent_loaded / 100) * e.loaded / e.total) }));
					}
				};
				return xhr;
			},
		}).done((json) => {
			setState(state=>({
				...state,
				progress:100,
				progress_status:(json.status == "1") ? true : false,
				progress_status_text:(json.status == "1") ? "The video has been uploaded successfully" : e.message,
			}));
			if(json.status == "1")this.change('video',json.name);
		}).fail((e) => {
			setState(state=>({
				...state,
				progress:100,
				progress_status:false,
				progress_status_text:"There has been an error",
			}));
		});
	}

	const change = (k, v) => {
		if(props.change !== undefined) props.change(k, v);

		const has_error = (props.errors && props.errors[props.name]) ? props.errors[props.name] : false;
		if(state.origin == 'upload' && props.upload_url != undefined && !has_error && state.progress == 0) {
			progress_upload(v);
		}
	}

	

	const switchToOrigin = (k, origin) => {
		setState(state=>({...state, origin:origin }));
	}

	const resetField = () => {
		file_uploader.current.remove();
	}

	const removeField = () => {
		setState(state=>({
			...state,
			progress:0,
			progress_status:null,
			progress_status_text:"",
			value:'',
		}));
	}

	const has_error = (props.errors && props.errors[props.name]) ? props.errors[props.name] : false;

	const _styles = props?._style ?? {};
	const _field_styles = props?._field_style ?? {};

	let classname = props?.classname ?? 'input video_picker';
	classname = parseClasses(classname, props._class, 'input');

	const disabled = props?.disabled ?? false;

	let field_class = ['common_form_item'];
	if(disabled) field_class.push('disabledField');

	var placeholder = '';
	switch(state.origin) {
		case 'youtube':
			placeholder = 'https://www.youtube.com/watch?v=1234567890';
			break;
		case 'vimeo':
			placeholder = 'https://vimeo.com/1234567';
			break;
	}

	return (
		<div class={'react_field' + ((props._field_class != undefined) ? ' ' + props._field_class : '')} onMouseEnter={(props.onMouseEnter != undefined) ? props.onMouseEnter : null} onMouseLeave={(props.onMouseLeave != undefined) ? props.onMouseLeave : null} onFocus={(props.onFocus != undefined) ? props.onFocus : null} onBlur={(props.onBlur != undefined) ? props.onBlur : null} onClick={(props.onClick != undefined) ? props.onClick : null} style={_field_styles}>
			<div class={classname + ((has_error) ? ' has_error' : '')} style={_styles}>
				{(props.children) && (
					<FieldLabel
						{...props.label_props}
						name={props.name}
						autotranslate={props.autotranslate}
						tooltip={props.tooltip}
					>{props.children}</FieldLabel>
				)}

				<div class="field_container this_input info_video">
					<div class="input_row video_inputs">
						{(state.origin != 'upload') ? (
							<UrlField
								placeholder={placeholder}
								name={props.name ?? 'video'}
								_class={{first:true, other:field_class.join(" ")}}
								change={change}
							/>
						) : (
							<div>
								<FileUploader
									onMount={(ref) => { file_uploader.current = ref; }}
									name={props.name}
									allowed='video'
									dd_size='full_w'
									_class={{ first:true, other:field_class.join(" ") }}
									small_input={true}
									change={change}
									onRemove={removeField}
								/>

								{(state.progress > 0) && (
									<div class="gui_progress_status">
										{(state.progress_status == undefined) ? (
											<ProgressBar
												actual={state.progress}
												max={100}
												display_percent={false}
												floating={true}
												_position="bottom"
											/>
										) : (
											<div class="bar" style={{width:'100%'}}>
												<span class="percent whiteColor hb_mainFontWeightRoman">{props.intl.formatMessage({id:state.progress_status_text})}</span>

												<span class={'colorBg ' + ((state.progress_status) ? 'greenBg' : 'redBg')} />

												<ButtonCollection>
													<SquaredButton
														onClick={resetField}
														color='white'
														icon='knk-reload'
														aria-label="Reset"
													/>
												</ButtonCollection>
											</div>
										)}
									</div>
								)}
							</div>
						)}

						<div class="video_origin full_video_origin">
							<ul>
								<li class={`video_upload${(state.origin == 'upload') ? ' selected' : ''}`}>
									<SquaredButton
										icon='knk-upload'
										_fullclass=''
										onClick={() => switchToOrigin('origin', 'upload')}
										aria-label="Switch to video upload"
									/>
								</li>

								<li class={`video_vimeo${(state.origin == 'vimeo') ? ' selected' : ''}`}>
									<SquaredButton
										icon='ep-vimeo'
										_fullclass=''
										onClick={() => switchToOrigin('origin', 'vimeo')}
										aria-label="Switch to Vimeo"
									/>
								</li>

								<li class={`video_youtube${(state.origin == 'youtube') ? ' selected' : ''}`}>
									<SquaredButton
										icon='ep-youtube'
										_fullclass=''
										onClick={() => switchToOrigin('origin', 'youtube')}
										aria-label="Switch to YouTube"
									/>
								</li>
							</ul>
						</div>
					</div>

					{(props.after_message != undefined) && (
						<div class="gui_after_message">{props.intl.formatMessage({id:props.after_message})}</div>
					)}

					{(props.after_component != undefined) && (
						<span class="label_additional_msg gui_after_message whole_contents">{props.after_component}</span>
					)}

					{(has_error) && (
						<FieldErrorMessage error_msg_position_class={props.error_msg_position_class}>{has_error}</FieldErrorMessage>
					)}
				</div>
			</div>
		</div>
	);
	
}

export default injectIntl(VideoPicker);